export default {"src":"/_next/static/media/tokko-vertical.f0c07407.svg","height":40,"width":64,"blurWidth":0,"blurHeight":0};